export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-folders-line',
      title: 'Produtos Organizados',
      desc: 'Categorias bem definidas para encontrar rapidamente o que você procura.',
    },
    {
      icon: 'ri-verified-badge-line',
      title: 'Links Verificados',
      desc: 'Todos os links são checados diariamente pela nossa equipe.',
    },
    {
      icon: 'ri-timer-line',
      title: 'Economia de Tempo',
      desc: 'Encontre os melhores produtos em minutos, não em horas.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Produtos Populares',
      desc: 'Selecionamos os itens mais desejados pela comunidade.',
    },
    {
      icon: 'ri-star-line',
      title: 'Melhores Vendedores',
      desc: 'Trabalhamos apenas com vendedores de alta reputação.',
    },
  ];

  return (
    <section id="beneficios" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Por que usar um <span className="text-accent-500">CSSBuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            Milhares de usuários usam o CSSBuy Spreadsheet para encontrar produtos de qualidade sem perder tempo procurando vendedores. Nossa seleção inclui apenas links verificados e atualizados.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {benefits.map((b, idx) => (
            <div
              key={idx}
              className="group flex flex-col items-center text-center p-6 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all duration-300"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-background-50 mb-4 group-hover:bg-accent-100 transition-colors">
                <i className={`${b.icon} text-foreground-700 group-hover:text-accent-600 text-2xl`}></i>
              </span>
              <h3 className="text-foreground-950 font-semibold text-sm mb-2">{b.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}